import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type saveData = {
    id?: any;
  };
  
  export const deleteUser = ({
   id
  }: saveData) => {
        return axios.delete(`/superAdmin/delete-user/${id}`);
    
  };
  
  type UseAddPetOptions = {
    config?: MutationConfig<typeof deleteUser>;
  };
  
  export const useDeleteUser = ({ config }: UseAddPetOptions = {}) => {
    return useMutation({
      onSuccess: (res: any, req: any) => {
        showNotification({
          type: 'success',
          title: 'User deleted successfully.',
        });
      },
      onError:()=>{
        showNotification({
          type: 'error',
          title: 'User has Funnels allocated to them and hence cannot be deleted',
      });
      },
      ...config,
      mutationFn: deleteUser,
    });
  };
  
